<template>
    <div class="home">
        <h1>home</h1>
        <div v-for="link in links" :key="link">
            <router-link :to="'/'+link">{{link}}</router-link>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue"

export default defineComponent({
    name: "HomeView",

    data() {
        return {
            links: [
                "register/1",
                "register/2",
                "intro",
                "leaderboards",
                "leaderboards-alltime",
                "leaderboards-daily",
                "leaderboards-daily-single",
                "games",
                "outro/1",
                "outro/2",
                "register-signage/1",
                "register-signage/2",
                "register-signage/3",
                "register-signage/4",
                "carousel/1",
                "carousel/2",
                "admin"
            ]
        }
    }
})
</script>

<style scoped lang="scss">
a {
    padding: 0.5rem;
    display: inline-block;
    font-size: 1.25rem;
}
</style>
